const cognitoConfig = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_k4N0sR6I6',
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '4j0esbuecrmn7u7872f5u1outj',
};

// The Movorra ECAP dashboard authenticates against its OWN dedicated Cognito pool (movorra-ecap in devl),
// separate from the pool the ride-share products use — so ECAP auth + tenancy never touch existing features.
// Sessions are isolated in localStorage by client id, so an ECAP login never collides with the existing one.
export const ecapCognitoConfig = {
  UserPoolId: process.env.REACT_APP_ECAP_COGNITO_USER_POOL_ID || 'us-east-1_FZgCgXPE5',
  ClientId: process.env.REACT_APP_ECAP_COGNITO_CLIENT_ID || '6j8s6gi9gkke5bsjk4s9gp6bep',
};

export default cognitoConfig;
